// extracted by mini-css-extract-plugin
export default {"item":"FileItem_item__K1J9Y","name":"FileItem_name__K3GgS"};